import React, { useEffect, useState } from "react"
import axios from "axios"

const withOccupancyData = ComponentToWrap => props => {

    const debug = props.search.debug ? true : false

    const [API_DATA, set_API_DATA] = useState('')
    const [OCCUPANCY_DATA, set_OCCUPANCY_DATA] = useState('')

    /**
    * Making the API call
    */
    const getOccupancy = props => {

        const env = process.env.NODE_ENV && process.env.NODE_ENV === 'development' ? 'dev' : 'prod'

        axios
            .get(`https://${process.env.GATSBY_AWS_API_ID}.execute-api.eu-west-1.amazonaws.com/${env}/getOccupancy`)
            .then(res => {
                set_API_DATA(res)
            });
    };


    /**
     * Correct the WIFI count - device by 2.2
     * @param {*} countFromAPI 
     * @param {*} devideFactor 
     */
    const wifiCountCorrection = (number, devideFactor) => {
        const factor = devideFactor ? devideFactor : 2.2
        return (number / factor).toFixed(0)
    }


    /**
     * Return the occupancy number - change into whatever we want to display - fixed number, percentage, etc
     * @param {int} countFromAPI
     * @returns value
     */
    const calculateOccupancy = (countFromAPI, max) => {
        const percentage = parseInt(((100 / max) * countFromAPI).toFixed(0))
        return percentage > 100 ? 100 : percentage
    }

    /**
  * Create occupancy columns from fetched numbers
  */
    useEffect(() => {

        if (API_DATA.data) {

            let occupancyRows = []

            props.BUILDING_NAMES_API.map((building_name, index) => {

                const clients = API_DATA.data[building_name] === undefined ? 0 : API_DATA.data[building_name]
                const clientsCorrection = wifiCountCorrection(clients, props.BUILDING_DEVIDEFACTOR[index])
                const occupancy = calculateOccupancy(clientsCorrection, props.BUILDING_CAPACITY[index])

                occupancyRows.push({
                    key: props.BUILDING_NAMES_DISPLAY[index],
                    title: props.BUILDING_NAMES_DISPLAY[index],
                    showArrow: index === 0 ? 'left' : index === props.BUILDING_NAMES_API.length - 1 ? 'right' : '',
                    occupancy: occupancy,
                    realNumber: clients,
                    correctionNumber: clientsCorrection,
                    correctionFactor: props.BUILDING_DEVIDEFACTOR[index],
                    buildingNumbers: props.BUILDING_CAPACITY[index],
                    debug: debug,
                })

                return true

            })

            set_OCCUPANCY_DATA(occupancyRows)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [API_DATA])


    /**
     * Run a counter every second
     */
    useEffect(() => {
        getOccupancy()
        const tickTimer = setInterval(() => getOccupancy(), (props.UPDATEINTERVAL * 1000))
        return () => clearInterval(tickTimer)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ComponentToWrap
            {...props}
            OCCUPANCY_DATA={OCCUPANCY_DATA}
        />
    )
}

export default withOccupancyData